import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import MenuIcon from "@mui/icons-material/Menu";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import NavigationMobile from "./NavigationMobile";
import GeoTabs, {
  getIndexFromSlug as getGeoIndex,
} from "../pages/geosafe/GeoTabs";
import SiTabs, {
  getIndexFromSlug as getSiIndex,
} from "../pages/sportsIntegrity/SiTabs";
import KycTabs, { getIndexFromSlug as getKycIndex } from "../pages/kyc/KycTabs";
import ContactTabs, {
  getIndexFromSlug as getContactIndex,
} from "../pages/contact/ContactTabs";
import { useEffect } from "react";

const tabsByPath = [
  { basePath: "/introduction", Component: GeoTabs, getIndex: getGeoIndex },
  { basePath: "/sports-integrity", Component: SiTabs, getIndex: getSiIndex },
  { basePath: "/kyc", Component: KycTabs, getIndex: getKycIndex },
  { basePath: "/contact", Component: ContactTabs, getIndex: getContactIndex },
];

function getActiveEntry(pathname) {
  return (
    tabsByPath.find(({ basePath }) => pathname.startsWith(basePath)) ?? null
  );
}

function getSlugFromPathname(pathname, basePath) {
  return pathname.replace(basePath, "").replace(/^\//, "") || null;
}

export default function NavigationDrawer() {
  const [open, setOpen] = useState(false);
  const [tabValues, setTabValues] = useState({});
  const location = useLocation();
  const [activePath, setActivePath] = useState(location.pathname);

  useEffect(() => {
    setActivePath(location.pathname);

    const entry = getActiveEntry(location.pathname);
    if (entry) {
      const slug = getSlugFromPathname(location.pathname, entry.basePath);
      const index = slug ? entry.getIndex(slug) : 0;
      setTabValues((prev) => ({ ...prev, [entry.basePath]: index }));
    }
  }, [location.pathname]);

  const handleDrawerOpen = () => {
    setActivePath(location.pathname);
    setOpen(true);
  };

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handleNavClick = (path) => {
    setActivePath(path);
  };

  const handleTabChange = (basePath) => (newValue) => {
    setTabValues((prev) => ({ ...prev, [basePath]: newValue }));
  };

  const activeEntry = getActiveEntry(activePath);
  const ActiveTabs = activeEntry?.Component ?? null;
  const activeBasePath = activeEntry?.basePath ?? null;

  const DrawerList = (
    <Box sx={{ width: 300 }} role="presentation" onClick={toggleDrawer(false)}>
      <Box onClick={toggleDrawer(false)}>
        <NavigationMobile onNavClick={handleNavClick} />
      </Box>
      {ActiveTabs && (
        <ActiveTabs
          value={tabValues[activeBasePath] ?? 0}
          onChange={handleTabChange(activeBasePath)}
        />
      )}
    </Box>
  );

  return (
    <div>
      <Button
        disableRipple
        sx={{
          all: "unset",
          cursor: "pointer",
          backgroundColor: "transparent",
          padding: "0",
          margin: "0",
          "&:hover": { backgroundColor: "transparent" },
        }}
        onClick={handleDrawerOpen}
      >
        <MenuIcon />
      </Button>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
}
